import styled from "styled-components";

export const PlanPriceContainer = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px 24px;
`;

export const PlanHeader = styled.div`
  margin-bottom: 12px;
`;

export const CancellationSection = styled.div`
  background: #f2f2f2;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e9ecef;
  margin: 12px 0;
`;
